import { getEnvMultiServer } from "../../helpers/env";

export const useMultiServer = () => { return getEnvMultiServer() };

export default {
  useMultiServer,
};
